import { createActions } from "redux-actions";

const actions = createActions({
    STARTUP: () => ({}),
    UPDATE_SESSION: (data) => ({data}),
    LOGIN_FAILED: (data) => ({data}),
    DO_LOGIN: ({user, password}) => ({user, password}),
    DO_LOGOUT: ()=>({})
})

export const startup = actions.startup;
export const updateSession = actions.updateSession;
export const doLogin = actions.doLogin;
export const doLogout = actions.doLogout;
export const loginFailed = actions.loginFailed;